import { TooltipProvider } from "@radix-ui/react-tooltip";
import { observer } from "mobx-react-lite";

import EvalTableSection from "../../TableComponents/EvalTableSection";
import BlueprintSidebar from "../Sidebar";

import { useEditBlueprint } from "./hooks/useEditBlueprint";
import { PreviewInfo } from "./PreviewInfo";

import LoadingSpinner from "@/components/LoadingSpinner";

export const EditBlueprint = observer(() => {
  const { blueprintColumnsIsLoading, blueprintCells, hiddenRows, reportContext } =
    useEditBlueprint();

  return (
    <div
      className={`flex h-full w-full pt-2 ${reportContext.isSidebarOpen ? "gap-x-6" : ""}`}
      data-entity-preview-core="report"
    >
      <div
        className={`flex min-h-0 flex-col overflow-hidden transition-[flex] duration-300 ease-in-out ${
          reportContext.isSidebarOpen && reportContext.selectedColumn ? "flex-[7]" : "flex-1"
        }`}
      >
        {blueprintColumnsIsLoading || blueprintCells === null ? (
          <div className="flex h-full w-full items-center justify-center">
            <LoadingSpinner />
          </div>
        ) : (
          <div className="flex min-h-0 flex-1 flex-col">
            <div className="flex min-h-0 flex-1 gap-x-4">
              <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
                <TooltipProvider>
                  <EvalTableSection />
                </TooltipProvider>
              </div>
            </div>
            <PreviewInfo hiddenRows={hiddenRows} />
          </div>
        )}
      </div>
      <BlueprintSidebar type={reportContext.selectedColumn?.id ? "update" : "create"} />
    </div>
  );
});

export default EditBlueprint;
